module.exports = __webpack_public_path__ + "media/customizations/emanuel/logo-c6134ea84123ba5f525f039c0882cdf6.png";